import { IGenericBusinessPartnersTableData } from '.';
import { IFilterModel } from '@components/widgets/listing-widget';
import { IAbstractRecord } from '@models';
import { IListingData } from '@models/listing';
import DateService from '@services/DateService';
import { capitalizeFirstLetter } from '@utils/formatting-utils';
import {
  enumListAsRecordObject,
  lookupListAsRecordObject,
} from '@utils/graph-utils';

export function mapToListingData(data: IAbstractRecord): IListingData {
  const list: IAbstractRecord = {};

  data.SalesforceManagement.queries.getBusinessPartnerList.items.forEach(
    (obj: IGenericBusinessPartnersTableData, i: number) => {
      list[i] = {
        salesforceManagement_BusinessPartner_Id:
          obj.salesforceManagement_BusinessPartner_Id,
        salesforceManagement_BusinessPartner_Code:
          obj.salesforceManagement_BusinessPartner_Code,
        person_FullName:
          obj.salesforceManagement_BusinessPartner_PersonID.views
            .SalesforceManagement_all.properties.FullName,
        salesforceManagement_BusinessPartner_Type:
          obj.salesforceManagement_BusinessPartner_Type?.Title,
        person_Email:
          obj.salesforceManagement_BusinessPartner_PersonID.views
            .SalesforceManagement_all.properties.Email,
        salesforceManagement_BusinessPartner_RelatedCompany:
          obj.salesforceManagement_BusinessPartner_RelatedCompany.Title,
        person_PhoneDetails:
          obj.salesforceManagement_BusinessPartner_PersonID.views
            .SalesforceManagement_all.properties.PhoneDetails?.PhoneNumber,
        salesforceManagement_BusinessPartner_Status: capitalizeFirstLetter(
          obj.salesforceManagement_BusinessPartner_Status?.replaceAll('_', ' ')
        ),
        salesforceManagement_BusinessPartner_createdOn:
          obj.salesforceManagement_BusinessPartner_createdOn,
        salesforceManagement_BusinessPartner_modifiedOn:
          obj.salesforceManagement_BusinessPartner_modifiedOn,
      };
    }
  );

  return {
    pagedItems: list,
    pageSize:
      data.SalesforceManagement.queries.getBusinessPartnerList?.paging
        ?.pageSize,
    pageNumber:
      data.SalesforceManagement.queries.getBusinessPartnerList?.paging
        ?.pageNumber,
    totalCount:
      data.SalesforceManagement.queries.getBusinessPartnerList?.paging
        ?.totalCount,
  };
}

export function toLookups(data: IAbstractRecord) {
  const lovs: Record<string, Record<string, string>> = {
    type: {},
    status: {},
    company: {},
  };

  lovs.type = lookupListAsRecordObject(
    data?.SalesforceManagement?.lookups?.businessPartnerTypes
  );
  lovs.company = lookupListAsRecordObject(
    data?.SalesforceManagement?.lookups?.relatedCompanies
  );
  lovs.status = enumListAsRecordObject(
    data?.SalesforceManagement_BusinessPartnerStatuses?.enumValues
  );

  return lovs;
}

export const getVariables = (filterValues: IFilterModel) => {
  const formattedDateRange = DateService.formatDateRangeBackend(
    filterValues.namedFilters.createdOn
  );
  return {
    pagination: filterValues.pagination,
    selectedTypes:
      filterValues.namedFilters?.type &&
      filterValues.namedFilters?.type?.length > 0
        ? filterValues.namedFilters?.type
        : [],
    isCompany:
      filterValues.namedFilters?.isCompany &&
      filterValues.namedFilters?.isCompany?.length > 0
        ? filterValues.namedFilters?.isCompany.map((bool: string) => {
            return bool === 'true';
          })
        : [],
    isLocal:
      filterValues.namedFilters?.isLocal &&
      filterValues.namedFilters?.isLocal?.length > 0
        ? filterValues.namedFilters?.isLocal.map((bool: string) => {
            return bool === 'true';
          })
        : [],
    isRegistered:
      filterValues.namedFilters?.isRegistered &&
      filterValues.namedFilters?.isRegistered?.length > 0
        ? filterValues.namedFilters?.isRegistered.map((bool: string) => {
            return bool === 'true';
          })
        : [],
    selectedRelatedCompany:
      filterValues.namedFilters?.company &&
      filterValues.namedFilters?.company?.length > 0
        ? filterValues.namedFilters?.company
        : [],
    businessPartnerStatus:
      filterValues.namedFilters?.status &&
      filterValues.namedFilters?.status?.length > 0
        ? filterValues.namedFilters?.status
        : [],
    createdDateFrom: formattedDateRange?.[0],
    createdDateTo: formattedDateRange?.[1],
    Attribute: filterValues.orderBy || 'Person_FullName',
    Descending: filterValues.descending || false,
    keywordSearch: filterValues.searchKey,
  };
};
